import Vue from "vue";
import axios from "axios";
import store from "@/store";
import i18n from "@/i18n";

import mDialog from "@/modules/dialog";
import mOrder from "@/modules/order";
import mUtils from "@/modules/utils";

import router from "@/plugins/router";

import { APP_MODE } from "@/modules/enums";
import { ORDER_TYPE } from "@/modules/enums";

const httpReqOpt = { withCredentials: true };
//const httpReqOpt = { withCredentials: true, headers: { Authorization: "Basic dGVzdDE6MTIzNDU2" } };
/*
const controller = new AbortController();
const signal = controller.signal;
const httpReqOpt = { withCredentials: true, signal: controller.signal };
const httpReqOpt = { signal };
*/

/*
const cancelToken = axios.CancelToken;
let cancelSource = cancelToken.source();
*/

export default {
  test() {
    //console.log(i18n.t("error_alert_title"));
    //console.log(Vue.$translate("error_alert_title"));
    //console.log(vuetify);
    /*
    let fullMenu = "2/12";
    let catIDs = [12, 23, 54];
    console.log("test result1", fullMenu.split("/"));
    let result = catIDs.some((i) => fullMenu.split("/").includes(i.toString()));
    console.log("test result2", result);
    */
  },

  async initApp(appToken) {
    console.log("initApp", appToken);
    let jreq = { ...appToken };
    jreq["app"] = store.getters.appInfo;
    let request = JSON.stringify(jreq);

    try {
      const result = await axios.post(store.getters.doApiUrl + "/init", request, store.state.httpReqOpt);
      const data = result.data;
      if (data.result == "ok") {
        store.state.launchTime = new Date();

        store.state.appInitialized = true;
        store.state.appData = data.data;
        store.state.appToken = appToken;
        if (!store.getters.appNoSessionId) store.state.appSessionId = data.sessionId;
        store.state.appSessionKey = data.sessionKey;
      }
      return data;
    } catch (error) {
      console.log(error);
    }
  },

  reloadApp() {
    window.location.reload();
  },

  async checkNetworkStatus(popupDialog = true) {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      await fetch('/favicon.ico', { method: 'HEAD', cache: 'no-store', signal: controller.signal });
      clearTimeout(timeoutId);
      return true;
    } catch {
      if (popupDialog) {
        mDialog.messageDialog.open("You are offline. Please check your internet connection.", "");
      }
      return false;
    }
    /*
    // not work in ios
    //
    if (!navigator.onLine) {
      mDialog.messageDialog.open("You are offline. Please check your internet connection.", "",);
    }

    return navigator.onLine;
    */
  },

  navPath(path, query) {
    //console.log("navPath", path, query);
    if (router.currentRoute.path != path) {
      router.push({
        path: path,
        query: query,
      });
    }
  },

  navName(name, params) {
    //console.log("navName", name, params);
    router
      .push({
        name: name,
        params: params,
      })
      .catch(() => { });
  },

  navRoot() {
    //console.log("navRoot", store.state.rootName);
    this.navName(store.state.rootName);
  },

  navBack() {
    if (Vue.prototype.$appMode == APP_MODE.APP) {
      if (router.currentRoute.name == "StoreHome") {
        this.navName("Stores");
      } else if (router.currentRoute.name == "MenuFull") {
        this.navName("Stores");
      } else if (router.currentRoute.name == "MenuCategory" && router.currentRoute.params.catID == null) {
        this.navName("Stores");
      } else {
        router.back();
      }
    } else if (store.getters.appName == "do-order") {
      if (router.currentRoute.name == "StoreHome" && store.state.rootName == "Stores") {
        this.navName("Stores");
      } else if (
        router.currentRoute.name == "MenuFull" &&
        (store.state.rootName == "Stores" || store.state.rootName == "StoreHome")
      ) {
        this.navName("StoreHome");
      } else if (
        router.currentRoute.name == "MenuCategory" &&
        router.currentRoute.params.catID === undefined &&
        (store.state.rootName == "Stores" || store.state.rootName == "StoreHome")
      ) {
        this.navName("StoreHome");
      } else {
        router.back();
      }
    } else {
      router.back();
    }
  },

  // store selected
  // params {orderType, skipConfirmation}
  // if price level is diff or new orderType is dinein, prompt for confirmation to clear cart
  async navMenu(params) {
    //console.log("navMenu", params);

    let orderType = store.state.Order.order.orderType;
    let skipConfirmation = false;
    if (params) {
      if (params.orderType) {
        if ([ORDER_TYPE.DINEIN, ORDER_TYPE.TAKEOUT, ORDER_TYPE.DELIVERY].includes(params.orderType))
          orderType = params.orderType;
      }
      skipConfirmation = params.skipConfirmation;
    }

    let switchOrderType = true;
    let om = store.getters.storeOrderType(orderType);

    let o_priceLevel = store.state.Order.order.priceLevel;
    let n_priceLevel = 0;
    if (om && om.priceLevel && Number.isInteger(om.priceLevel)) n_priceLevel = om.priceLevel;

    if (!skipConfirmation && store.state.Order.order.orderItems.length > 0) {
      if (o_priceLevel != n_priceLevel) {
        switchOrderType = await mDialog.confirmDialog.open(
          i18n.t("confirm_title_switch_ordertype") + i18n.t(orderType) + "?",
          "",
          i18n.t("confirm_leave_clear_cart"),
          { yesText: i18n.t("confirm_button_switch") }
        );
      } else {
        if (orderType == ORDER_TYPE.DINEIN) {
          let promoOi = store.state.Order.order.orderItems.find(x => x.promo);
          if (promoOi) {
            switchOrderType = await mDialog.confirmDialog.open(
              i18n.t("confirm_title_switch_ordertype") + i18n.t(orderType) + "?",
              "",
              i18n.t("confirm_leave_remove_promo_cart"),
              { yesText: i18n.t("confirm_button_switch") }
            );
          }
        }
      }
    }

    if (switchOrderType) {
      let res = await mOrder.setOrderType(orderType);
      if (res) {
        this.navName(store.getters.menuHome, params);
      }
    }
  },

  async isMenuDisabled() {
    let jreq = store.state.appToken;
    let request = JSON.stringify(jreq);

    try {
      const result = await axios.post(store.getters.doApiUrl + "/init", request, store.state.httpReqOpt);
      const data = result.data;
      return data.result != "ok" || data.menuDisabled === true;
    } catch (error) {
      console.log(error);
      return true;
    }
  },

  isFullScreenDialog() {
    return window.innerWidth < 600;
  },

  getLaunchTime() {
    let time = null;
    let key = "LTM_" + store.getters.storageKey;
    if (localStorage.getItem(key)) {
      time = mUtils.toDate(localStorage.getItem(key));
    }

    return time;
  },

  setLaunchTime() {
    let key = "LTM_" + store.getters.storageKey;
    localStorage.setItem(key, Date());
  },

  getLaunchMin() {
    let currentTime = new Date();
    let launchMin = (currentTime.getTime() - store.state.launchTime.getTime()) / 1000 / 60;

    return launchMin;
  },

  verifyAppPin(payload) {
    return this.apiPost(store.getters.apiUrl + "/app/verifyapppin", {
      sessionKey: store.state.Store.store.sessionKey,
      appKey: store.getters.appKey,
      appPin: payload.appPin,
    });
  },

  /*
  async isSessionValid() {
    let valid = true;
    let launchMin = store.getters.launchMin();

    if (launchMin < 180 || store.getters.appName == "mrs.app.kiosk" || store.getters.appName == "mrs.app.orderpad") {
      let checkInterval = 15;
      let now = new Date();
      let durationMin = (now - store.state.appSessionIdModifiedTime) / 1000 / 60;
      if (durationMin > checkInterval) {
        let n_appSessionId = await this.getSessionId();
        store.state.appSessionIdModifiedTime = now;
        if (n_appSessionId != store.state.appSessionId) {
          valid = false;
        }
      }
    } else valid = false;

    if (!valid) {
      mDialog.messageDialog.open(i18n.t("session_expired"), "", i18n.t("page_reloading"));
      setTimeout(() => window.location.reload(), 2000);
    }
    return valid;
  },
  */

  checkAppTimeout() {
    let launchMin = this.getLaunchMin();
    let timeout = launchMin > 180;

    if (timeout) {
      // If page is hidden (suspended/backgrounded), defer reload until visible
      if (document.visibilityState === "hidden") {
        console.log("[app] checkAppTimeout - deferring reload, page is hidden");
        const deferredReload = () => {
          document.removeEventListener("visibilitychange", deferredReload);
          mDialog.messageDialog.open(i18n.t("session_expired"), "", i18n.t("page_reloading"));
          setTimeout(() => window.location.reload(), 2000);
        };
        document.addEventListener("visibilitychange", deferredReload);
      } else {
        mDialog.messageDialog.open(i18n.t("session_expired"), "", i18n.t("page_reloading"));
        setTimeout(() => window.location.reload(), 2000);
      }
    }
    return timeout;
  },

  checkDineinExpired() {
    if (Vue.prototype.$devEnv) return false;

    if (store.state.Order.order.tableID > 0) {
      let key = 'expiry_time';
      const expiry_time = sessionStorage.getItem(key);
      if (expiry_time) {
        const now = new Date().getTime();
        if (now > parseInt(expiry_time)) {
          mDialog.messageDialog
            .open(i18n.t("session_expired"), "", i18n.t("rescan_qr_code"), { fullscreen: false, buttonText: "" });
          return true;
        }
      }
    }
    return false;
  },

  getSessionId() {
    //console.log("getSessionId");

    let jreq = {};
    let request = JSON.stringify(jreq);

    return axios
      .post(store.getters.apiUrl + "/sessionId", request, store.state.httpReqOpt)
      .then(result => result.data)
      .then(data => {
        return data.sessionId;
      })
      .catch(error => {
        console.log(error);
        return null;
      });
  },

  async apiPost(url, req) {
    //console.log("apiPost", url, req);

    if (store.getters.appReloadAtTimeout) {
      let timeout = await this.checkAppTimeout();
      if (timeout) {
        return { result: "Session Expired" };
      }
    }

    req["sessionId"] = store.state.appSessionId;
    req["app"] = store.getters.appInfo;

    let request = JSON.stringify(req);
    try {
      let resp = await axios.post(url, request, httpReqOpt);
      if (resp?.data) {
        return resp.data;
      } else return false;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  /*
  apiPost(url, req) {
    return this.isSessionValid().then((valid) => {
      if (!valid) {
        return new Promise(function(resolve) {
          resolve({ result: "Session Expired" });
        });
      }

      req["sessionId"] = Vue.prototype.$appMode == APP_MODE.WEB ? undefined : store.state.appSessionId;
      req["app"] = store.getters.appInfo;
      //req["debug"] = Vue.prototype.$devEnv ? true : undefined;
      let request = JSON.stringify(req);

      return axios
        .post(url, request, httpReqOpt)
        .then((result) => result.data)
        .then((data) => {
          return data;
        })
        .catch((error) => {
          return error;
        });
    });
  },
  */
};
